import { useEffect, useState } from "react";
import { SEO } from "@/components/SEO";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";
import { Layout } from "@/components/Layout";
import { Gamepad2 } from "lucide-react";
import DeveloperDashboard from "./DeveloperDashboard";
import CreatorDashboard from "./CreatorDashboard";
import PlayerDashboard from "./PlayerDashboard";
import { DashboardMissions } from "@/components/DashboardMissions";

export default function Dashboard() {
  const { user, loading, signOut } = useAuth();
  const navigate = useNavigate();
  const [userType, setUserType] = useState<string | null>(null);
  const [loadingProfile, setLoadingProfile] = useState(true);

  useEffect(() => {
    if (!loading && !user?.id) {
      navigate("/auth");
    }
  }, [user?.id, loading, navigate]);

  useEffect(() => {
    const fetchProfile = async () => {
      if (user?.id) {
        const { data } = await supabase
          .from("profiles")
          .select("user_type")
          .eq("id", user.id)
          .single();

        setUserType(data?.user_type || null);
        setLoadingProfile(false);
      }
    };

    fetchProfile();
  }, [user?.id]);

  if (loading || loadingProfile) {
    return (
      <div className="min-h-screen hero-gradient flex items-center justify-center">
        <div className="animate-spin">
          <Gamepad2 className="w-12 h-12 text-primary" />
        </div>
      </div>
    );
  }

  return (
    <Layout>
      <SEO
        title="Dashboard"
        description="Manage your IndieKeys account, games, and keys."
      />
      {userType === "developer" ? (
        <DeveloperDashboard />
      ) : userType === "player" ? (
        <PlayerDashboard />
      ) : (
        <CreatorDashboard />
      )}
    </Layout>
  );
}
